module.exports = __webpack_public_path__ + "files/a2b6ce06e3de4f61611146cae9533c20.png";